import { getPieceFilterMapping } from "../../features/createSecondaryOrder/CreateSecondaryOrderService";
import { CartProduct } from "../../features/createSecondaryOrder/models";

export const getSkuData = (product: CartProduct) => {
  return {
    productUI: product,
    orderDetails: [
      {
        extendedAttributes: { blobKey: product?.imageUrl },
        skuDescription: product?.name,
        batchCode: product?.batchCode,
        caseQuantity: product?.availableCaseQty,
        pieceQuantity: product?.availablePieceQty,
        discountInfo: product?.schemes?.map((scheme: any) => {
          return { ...scheme, discountInfo: scheme?.schemeDescription };
        }) || [],
        mrp: product?.mrp,
        caseMrp: product?.caseMrp,
        pieceSize: getPieceFilterMapping(product?.pieceSize?.toString()),
        productInfo: { skuDescription: product?.name ?? "" }
      },
    ],
  };
};

export const getUnitLabel = (
  quantity: number | string | null | undefined
): 'UNIT' | 'UNITS' => {
  const parsedQuantity =
    typeof quantity === 'string' ? Number(quantity) : quantity ?? 0;
  return parsedQuantity === 1 ? 'UNIT' : 'UNITS';
};
